import { useAuth0 } from '@auth0/auth0-react';
import { useAnalytics } from '@effects/useAnalytics';
import React, { useEffect } from 'react';

const GTMUserTracker: React.FC = () => {
    const { isAuthenticated, user, isLoading } = useAuth0();

    const { setUserId } = useAnalytics();

    useEffect(() => {
        // Only proceed if not loading, user is authenticated, and user object exists
        if (!isLoading && isAuthenticated && user) {
            const userId = user.sub;
            if (userId) {
                setUserId(userId);
            }
        }
    }, [isAuthenticated, user, isLoading, setUserId]);

    return null;
};

export default GTMUserTracker;
